export default class Uploader {
  constructor($dropContainer, $uploadingMessage, cb) {
    this.cb = cb;
    this.maxSize = 52428800; // 50MB
    this.$dropContainer = $dropContainer;
    this.$uploadingMessage = $uploadingMessage;
    this.$input = $dropContainer.querySelector("input");
    this.folderName = null;
    this.parentFolder = null;
    this.uploadedFiles = 0;

    this.setupListeners();
  }

  setFolder(name, parentFolder) {
    this.folderName = name;
    this.parentFolder = parentFolder;
  }

  setupListeners() {
    this.$dropContainer.addEventListener("click", (e) => {
      if (["INPUT", "SELECT"].includes(e.target.tagName)) {
        return;
      }
      this.$input.click();
    });
    this.$dropContainer.addEventListener("dragover", (e) => {
      e.preventDefault();
    });
    this.$dropContainer.addEventListener("drop", (e) => {
      e.preventDefault();
      if (e.dataTransfer.items) {
        this.filesToUpload = 0;
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          if (e.dataTransfer.items[i].kind === "file") {
            this.filesToUpload++;
            let file = e.dataTransfer.items[i].getAsFile();
            this.uploadFile(file);
          }
        }
      } else {
        this.filesToUpload = e.dataTransfer.files.length;
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.uploadFile(e.dataTransfer.files[i]);
        }
      }
    });

    this.$input.addEventListener("change", () => {
      this.uploadFiles();
    });
  }

  uploadFiles() {
    this.filesToUpload = this.$input.files.length;
    [...this.$input.files].forEach((file) => {
      this.uploadFile(file);
    });
  }

  hideUploadingMessage() {
    this.$dropContainer.classList.remove("d-none");
    this.$uploadingMessage.classList.add("d-none");
  }

  uploadFile(file) {
    this.$dropContainer.classList.add("d-none");
    this.$uploadingMessage.classList.remove("d-none");

    if (file.size > this.maxSize) {
      this.hideUploadingMessage();
      peque.navigation.showError("File size is too big");
      return;
    }

    const formData = new FormData();
    formData.append("company", window.currentCompany.id);
    formData.append("document", file);

    if (this.folderName != null) {
      formData.append("folder_name", this.folderName);
      formData.append("parent_folder", this.parentFolder);
    }

    peque
      .api("documents", formData, "post")
      .then((response) => {
        this.uploadedFiles++;
        this.cb(response.result);
        if (this.uploadedFiles === this.filesToUpload) {
          this.hideUploadingMessage();
          this.uploadedFiles = 0;
        }
      })
      .catch((response) => {
        this.hideUploadingMessage();

        if (typeof response === "string") {
          peque.navigation.showError(trans("file_size_is_too_big"));
        } else if (typeof response.result !== "undefined") {
          peque.navigation.showError(response.result);
        }
      });
  }
}

window.Uploader = Uploader;
